
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-payment-edit',
  templateUrl: './payment-edit.component.html'
})
export class PaymentEditComponent implements OnChanges, OnInit {

  @Input() rowdata;
  @Input() payment;
  @Output() doSave = new EventEmitter();
  @Output() doCancel = new EventEmitter();
  form;
  

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      paymentId: ['', ''],
      paidDate: ['', ''],
      paidAmount: ['', ''],
      memberId: ['', '']
    });
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.payment.currentValue) {
      this.form?.patchValue(changes?.payment.currentValue);
      this.form?.patchValue({ memberId: this.rowdata.memberId });
    }
  }

  savePayment() {
    this.doSave.emit(this.form.value);
  }

  cancel() {
    this.doCancel.emit();
  }
}
